<p-card [style]="{ margin: 0, height: '100%' }">
  <div class="flex align-items-center gap-2 mb-3">
    <i class="pi pi-server text-xl"></i>
    <h2 class="m-0">Monitoring des Jobs</h2>
  </div>

  <p-tabView>
    <!-- ===== JOBS EN ATTENTE ===== -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span>
          <i class="pi pi-clock mr-2"></i>
          En attente
          @if (pendingTotal$ | async; as total) {
            <p-tag
              [value]="total.toString()"
              severity="info"
              class="ml-2"
            ></p-tag>
          }
        </span>
      </ng-template>

      <p-table
        [value]="(pendingJobs$ | async) || []"
        [loading]="(pendingLoading$ | async) ?? false"
        [lazy]="true"
        [paginator]="true"
        [rows]="15"
        [rowsPerPageOptions]="[15, 30, 50]"
        [totalRecords]="(pendingTotal$ | async) || 0"
        (onLazyLoad)="onPendingLazyLoad($event)"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>#</th>
            <th>Job</th>
            <th>Queue</th>
            <th>Tentatives</th>
            <th>Statut</th>
            <th>Créé le</th>
            <th>Disponible le</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-job>
          <tr>
            <td>{{ job.id }}</td>
            <td>
              <span
                [pTooltip]="job.jobName"
                tooltipPosition="top"
                class="cursor-pointer"
                >{{ shortJobName(job.jobName) }}</span
              >
            </td>
            <td>
              <code>{{ job.queue }}</code>
            </td>
            <td>{{ job.attempts }}</td>
            <td>
              <p-tag
                [value]="job.status === 'reserved' ? 'Réservé' : 'En attente'"
                [severity]="getStatusSeverity(job.status)"
              ></p-tag>
            </td>
            <td>{{ job.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ job.availableAt | date: 'dd/MM/yyyy HH:mm' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" class="text-center text-color-secondary py-4">
              <i class="pi pi-check-circle mr-2 text-green-500"></i>
              Aucun job en attente
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>

    <!-- ===== JOBS ECHOUES ===== -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span>
          <i class="pi pi-times-circle mr-2"></i>
          Échoués
          @if (failedTotal$ | async; as total) {
            <p-tag
              [value]="total.toString()"
              [severity]="total > 0 ? 'danger' : 'success'"
              class="ml-2"
            ></p-tag>
          }
        </span>
      </ng-template>

      <p-table
        [value]="(failedJobs$ | async) || []"
        [loading]="(failedLoading$ | async) ?? false"
        [lazy]="true"
        [paginator]="true"
        [rows]="15"
        [rowsPerPageOptions]="[15, 30, 50]"
        [totalRecords]="(failedTotal$ | async) || 0"
        (onLazyLoad)="onFailedLazyLoad($event)"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>#</th>
            <th>Job</th>
            <th>Queue</th>
            <th>Connexion</th>
            <th>Échoué le</th>
            <th>Exception</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-job>
          <tr>
            <td>{{ job.id }}</td>
            <td>
              <span
                [pTooltip]="job.jobName"
                tooltipPosition="top"
                class="cursor-pointer"
                >{{ shortJobName(job.jobName) }}</span
              >
            </td>
            <td>
              <code>{{ job.queue }}</code>
            </td>
            <td>
              <code>{{ job.connection }}</code>
            </td>
            <td>{{ job.failedAt | date: 'dd/MM/yyyy HH:mm' }}</td>
            <td>
              <span
                class="exception-preview"
                [pTooltip]="job.exception"
                tooltipPosition="left"
                >{{ job.exception | slice: 0 : 80 }}…</span
              >
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center text-color-secondary py-4">
              <i class="pi pi-check-circle mr-2 text-green-500"></i>
              Aucun job échoué
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-tabPanel>
  </p-tabView>
</p-card>
